import { render, staticRenderFns } from "./importList.vue?vue&type=template&id=2dfe6ad6&"
import script from "./importList.vue?vue&type=script&lang=js&"
export * from "./importList.vue?vue&type=script&lang=js&"
import style0 from "./importList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports